import { useQuery } from '@tanstack/react-query';
import { http } from 'services/http';
import { TRIPS_LOAD_AGGREGATED_STATISTICS_GET } from 'api/query-keys';
import type { TGetTripsLoadAggregatedStatisticsRes } from 'api/swagger';
import type { ITransportLoadFilter } from 'shared/stores/use-transport-load-filters';
import { setFiltersToQs } from 'shared/utils/filters/set-filters-to-qs';

interface IParams {
  filters: ITransportLoadFilter;
}

export const useGetTripsLoadAggregatedStatistics = ({ filters }: IParams) => {
  const qs = new URLSearchParams();
  setFiltersToQs<ITransportLoadFilter>(qs, filters);

  return useQuery({
    queryKey: [TRIPS_LOAD_AGGREGATED_STATISTICS_GET, { filters }],
    queryFn: async () => {
      const { data } = await http.get<TGetTripsLoadAggregatedStatisticsRes>(
        `/v1/statistics/trips-load-by-manager-aggregated?${qs.toString()}`,
      );
      return data;
    },
    retry: false,
    refetchOnWindowFocus: false,
    enabled: !!filters.date && !!filters.userId,
  });
};
